// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .change-tab {
  padding: 50px 20px 20px 20px;
}
.popup .change-tab h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .change-tab .tabs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}
.popup .change-tab .tabs .tab {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1 1;
  max-width: 49%;
  margin: 5px 0;
}
.popup .change-tab .tabs .tab input[type=radio] {
  display: none;
}
.popup .change-tab .tabs .tab label {
  color: #C9A370;
  background: #F2F2F2;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-style: normal;
  font-weight: normal;
  font: 1.2em/1.3em vigaregular;
  padding: 10px 15px 20px 15px;
  text-align: center;
  min-height: 100px;
  cursor: pointer;
}
.popup .change-tab .tabs .tab label .icon {
  margin-top: -10px;
  max-height: 85px;
  height: 14vw;
  filter: invert(1);
}
.popup .change-tab .tabs .tab label span {
  margin-top: -10px;
  width: 100%;
}
.popup .change-tab .tabs .tab input[type=radio]:checked + label {
  background: #C9A370;
  color: #F2F2F2;
}
.popup .change-tab .tabs .tab input[type=radio]:checked + label .icon {
  filter: invert(0);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/ChangeTabContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAEQ;EACI,uBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;AADZ;AAGY;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AADhB;AAGgB;EACI,aAAA;AADpB;AAGgB;EACI,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AADpB;AAGoB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AADxB;AAIoB;EACI,iBAAA;EACA,WAAA;AAFxB;AAKgB;EACI,mBAAA;EACA,cAAA;AAHpB;AAIoB;EACI,iBAAA;AAFxB","sourcesContent":[".popup {\n    .change-tab {\n        padding: 50px 20px 20px 20px;\n\n        h2 {\n            font: 2em/1 vigaregular;\n            color: #5c5c5c;\n        }\n\n        .tabs{\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            width: 100%;\n            justify-content: space-between;\n\n            .tab{\n                display: flex;\n                flex-direction: column;\n                flex-basis: 100%;\n                flex: 1;\n                max-width: 49%;\n                margin: 5px 0;\n\n                input[type=\"radio\"]{\n                    display: none;\n                }\n                label{\n                    color: #C9A370;\n                    background: #F2F2F2;\n                    border-radius: 10px;\n                    display: inline-flex;\n                    align-items: center;\n                    justify-content: center;\n                    flex-wrap: wrap;\n                    font-style: normal;\n                    font-weight: normal;\n                    font: 1.2em/1.3em vigaregular;\n                    padding: 10px 15px 20px 15px;\n                    text-align: center;\n                    min-height: 100px;\n                    cursor: pointer;\n\n                    .icon{ \n                        margin-top: -10px;\n                        max-height: 85px;\n                        height: 14vw;\n                        filter: invert(1);\n                    }\n\n                    span{\n                        margin-top: -10px;\n                        width: 100%;\n                    }\n                }\n                input[type=\"radio\"]:checked+label{ \n                    background: #C9A370;\n                    color: #F2F2F2;\n                    .icon{\n                        filter: invert(0);\n                    }\n                } \n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
